<template>
  <section class="publication-single">
    <PublicationSingleHeader :publication="publication" />
    <PublicationSingleContent v-if="publication && publication.content" :publication="publication" />
    <PublicationSingleMore v-if="publication" :publication="publication" />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'PublicationSingle',
  components: { ...partials },
  props: {
    publicationSlug: String
  },
  computed: {
    publication() {
      if (!this.$wp.secondaryDataLoaded) return null
      return this.$wp.allPublications[this.publicationSlug] || null
    }
  },
  mounted() {
    this.$watch(
      '$wp.secondaryDataLoaded',
      isLoaded => {
        if (isLoaded) {
          console.log('Publication loaded:', this.publication)
        }
      },
      { immediate: true }
    )
  }
}
</script>
